import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrashIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.66665 2.66732V1.33398H11.3333V2.66732H14.6666V4.00065H13.3333V14.0007C13.3333 14.3688 13.0348 14.6673 12.6666 14.6673H3.33331C2.96512 14.6673 2.66665 14.3688 2.66665 14.0007V4.00065H1.33331V2.66732H4.66665ZM3.99998 4.00065V13.334H12V4.00065H3.99998ZM5.99998 6.00065H7.33331V11.334H5.99998V6.00065ZM8.66665 6.00065H9.99998V11.334H8.66665V6.00065Z",
		fill: "#CE0500"
	})
});
export default SvgTrashIcon;
